import React from "react";
import { useField } from "formik";
import "./form.scss";

/**
 * Native `textarea` input wrapper with Formik integration.
 * @param {{
 * name: string,
 * label: string,
 * placeholder?: string,
 * rows?: number,
 * disabled?: boolean
 * }} props
 * @returns {React.FunctionComponent}
 */
export default function TextArea({
    name,
    label,
    rows = 3,
    placeholder,
    ...rest
}) {
    const [field, meta] = useField({ name, label, placeholder, ...rest });
    return (
        <div className="w-100">
            {label && (
                <label htmlFor={name} className="form-label">
                    {label}
                </label>
            )}
            <textarea
                id={name}
                className="form-control"
                placeholder={placeholder || ""}
                rows={rows}
                {...field}
                {...rest}
            />

            <div
                hidden={!(meta.touched && meta.error)}
                className="invalid-feedback"
                style={{ display: "block" }}
            >
                {meta.error}
            </div>
        </div>
    );
}
